import React from 'react';
import { Box, Spinner, Text, VStack } from '@chakra-ui/react';
import { surveyTheme as theme } from './surveyTheme';
import { t } from './translations';

/**
 * LoadingScreen - Simple loading state
 */
const LoadingScreen = () => {
  // Read lang from URL since component state isn't available yet
  const urlParams = new URLSearchParams(window.location.search);
  const lang = urlParams.get('lang') === 'es' ? 'es' : 'en';

  return (
    <Box
      minH="100vh"
      bg={theme.colors.background}
      display="flex"
      alignItems="center"
      justifyContent="center"
    >
      <VStack spacing={4}>
        <Spinner
          size="lg"
          color={theme.colors.teal}
          thickness="3px"
        />
        <Text
          fontSize="15px"
          color={theme.colors.textMuted}
          fontFamily={theme.typography.fontFamily}
        >
          {t(lang, 'loadingSurvey')}
        </Text>
      </VStack>
    </Box>
  );
};

export default LoadingScreen;
